import { api } from '../App';

// Clerk proves who someone is; Zuriya then issues its own session cookie.
export async function exchangeClerkSession(clerk, extra = {}) {
  const token = await clerk.session?.getToken();
  if (!token) throw new Error('Your sign-in did not complete. Please try again.');
  const res = await api.post('/auth/clerk/exchange', extra, { headers: { Authorization: `Bearer ${token}` } });
  return res.data;
}

export async function linkExistingAccount(email, password) {
  await api.post('/auth/clerk/link-existing', password === undefined ? { email } : { email, password });
}

export function clerkErrorCode(err) {
  return err?.errors?.[0]?.code;
}

export function authErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  const clerkMsg = err?.errors?.[0]?.longMessage || err?.errors?.[0]?.message;
  const detail = err?.response?.data?.detail;
  return clerkMsg || (detail && typeof detail === 'object' ? detail.message : detail) || err?.message || fallback;
}

// Same routing the old password login used, including the 2FA hand-off.
export async function routeAfterLogin(data, { navigate, checkAuth, from = '/' }) {
  if (data.requires_2fa) {
    navigate('/auth/2fa', {
      replace: true,
      state: {
        challengeToken: data.challenge_token, method: data.method, emailMasked: data.email_masked,
        otpExpiresAt: data.otp_expires_at, redirectFrom: from,
      },
    });
    return;
  }
  try { await checkAuth(); } catch (err) { console.error('Auth check after login:', err); }
  if (data.must_setup_2fa) return navigate('/auth/2fa/setup', { replace: true });
  if (data.role === 'admin') return navigate('/admin/z-control', { replace: true });
  if (data.role === 'provider') {
    return navigate(data.is_new ? '/provider/onboarding' : '/provider/dashboard', { replace: true });
  }
  return navigate(data.is_new ? '/discover' : (from === '/' ? '/dashboard' : from), { replace: true });
}

// Sign-in attempts that stop for a device check are finished with an email code.
export async function startSecondFactorEmail(signIn) {
  const factor = signIn.supportedSecondFactors?.find((f) => f.strategy === 'email_code');
  if (!factor) throw new Error('Email codes are not switched on for sign-in.');
  await signIn.prepareSecondFactor({ strategy: 'email_code', emailAddressId: factor.emailAddressId });
}
